module.exports = __webpack_public_path__ + "img/cu.ef70ab2e.svg";